import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { sz, txt, useContent } from "@/content/ContentContext";

const CONSENT_KEY = "itds-cookie-consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();
  const c = useContent();
  const banner = c.global.cookieBanner;

  useEffect(() => {
    let stored = null;
    try {
      stored = window.localStorage.getItem(CONSENT_KEY);
    } catch (err) {
      stored = null;
    }
    if (!stored) {
      setVisible(true);
    }
  }, []);

  if (pathname.startsWith("/admin")) {
    return null;
  }

  const choose = (value) => {
    try {
      window.localStorage.setItem(CONSENT_KEY, value);
    } catch (err) {
      // Storage unavailable; hide the banner for this visit only.
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
      <p className="cookie-text" style={sz(banner.text)}>
        {txt(banner.text)}{" "}
        <Link to="/cookie-policy" className="cookie-link" data-testid="cookie-policy-link">
          Cookie Policy
        </Link>
      </p>
      <div className="cookie-actions">
        <button
          type="button"
          className="cookie-btn cookie-btn-ghost"
          onClick={() => choose("declined")}
          data-testid="cookie-decline-btn"
        >
          {txt(banner.declineLabel)}
        </button>
        <button
          type="button"
          className="cookie-btn cookie-btn-solid"
          onClick={() => choose("accepted")}
          data-testid="cookie-accept-btn"
        >
          {txt(banner.acceptLabel)}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
